import React, { useState, useRef, useEffect } from "react";
import FrameworksSection from '../framework/frameworksection';
import DesktopGuiToolsSection from '../uitools/DesktopGuiToolsSection';
import MLSection from '../aitools/LibraryToolSection';
import EdgeTechSection from '../edgetechtools/EdgeTechSection';
import ProjectsSection from '../projectsection/ProjectsSection'; // 👈 NEW

import {
  Container,
  ButtonsContainer,
  ToggleButton,
  SectionsContainer,
  ArrowBadge
} from "./styles";

const sections = [
  { name: "EdgeTechSection", component: EdgeTechSection, label: "Embedded Systems" },
  { name: "DesktopGuiToolsSection", component: DesktopGuiToolsSection, label: "Desktop Applications" },
  { name: "FrameworksSection", component: FrameworksSection, label: "Web Systems" },
  { name: "MLSection", component: MLSection, label: "Edge AI Systems" },
];

const PortfolioSections = () => {
  const [visibleSection, setVisibleSection] = useState(sections[0].name);
  const [isMobile, setIsMobile] = useState(false);

  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      setVisibleSection(prev => {
        const currentIndex = sections.findIndex(s => s.name === prev);
        const nextIndex = (currentIndex + 1) % sections.length;
        return sections[nextIndex].name;
      });
    }, 15000);
  };

  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);

    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const sectionRefs = useRef({});
  sections.forEach(sec => {
    sectionRefs.current[sec.name] =
      sectionRefs.current[sec.name] || React.createRef();
  });

  // AUTO SLIDE (desktop only)
  useEffect(() => {
    if (isMobile) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      return; 
    }

    startAutoSlide();

    // "Focus" listener para ma-reset ang slide pagbalik ng employer sa tab mo
    const handleFocus = () => startAutoSlide();
    window.addEventListener("focus", handleFocus);

    return () => {
      clearInterval(intervalRef.current);
      window.removeEventListener("focus", handleFocus);
    };
  }, [isMobile]);

  const handleToggle = (sectionName) => {
    if (isMobile) return;

    setVisibleSection(sectionName);

    startAutoSlide();

    const sectionRef = sectionRefs.current[sectionName]?.current;
    if (sectionRef) {
      sectionRef.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <Container>
      <ButtonsContainer>
        {sections.map(sec => (
          <ToggleButton
            key={sec.name}
            onClick={() => handleToggle(sec.name)}
          >
            {sec.label}
            {!isMobile && (
              <ArrowBadge>
                {visibleSection === sec.name ? "▲" : "▼"}
              </ArrowBadge>
            )}
          </ToggleButton>
        ))}
      </ButtonsContainer>

      <SectionsContainer
        onMouseEnter={() => !isMobile && clearInterval(intervalRef.current)} 
        onMouseLeave={() => !isMobile && startAutoSlide()}
      >
        {sections.map(sec => {
          const Component = sec.component;

          if (isMobile) {
            return (
              <div key={sec.name}>
                <Component />
                <ProjectsSection category={sec.name} /> {/* 👈 MOBILE SHOWS ALL */}
              </div>
            );
          }

          return (
            visibleSection === sec.name && (
              <div key={sec.name} ref={sectionRefs.current[sec.name]}>
                <Component />
                <ProjectsSection category={sec.name} /> {/* 👈 SYNCED */}
              </div>
            )
          );
        })}
      </SectionsContainer>
    </Container>
  );
};

export default PortfolioSections;